<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="data"
      :loading="loading"
      loading-text="Загружаю Менеджерів"
      sort-by="messageCount"
      class="elevation-1"
      :items-per-page="15"
      :footer-props="{
        'items-per-page-options': [15, 30, 50, -1],
      }"
      height="calc(100vh - 177px)"
    >
      <template v-slot:item.messagesCount="{ item }">
        <v-chip>{{ item.messagesCount || 0 }}</v-chip>
      </template>

      <template v-slot:item.serviceRating="{ item }">
        <div class="d-flex align-center justify-center">
          <div class="d-flex align-center mr-4">
            <span class="mr-1">😄</span>
            <div class="green--text">
              {{ item.serviceRating ? item.serviceRating.voteGood : 0 }}
            </div>
          </div>

          <div class="d-flex align-center mr-4">
            <span class="mr-1">🙂</span>
            <div class="amber--text text--darken-2">
              {{ item.serviceRating ? item.serviceRating.voteNeutral : 0 }}
            </div>
          </div>

          <div class="d-flex align-center mr-4">
            <span class="mr-1">☹️</span>
            <div class="red--text">
              {{ item.serviceRating ? item.serviceRating.voteBad : 0 }}
            </div>
          </div>

          <div class="d-flex align-center">
            <div class="d-flex align-center mr-4">
              <v-icon color="orange" size="medium" class="mr-1"
                >mdi-thumbs-up-down-outline</v-icon
              >
              <span class="green--text">
                {{ item.serviceRating ? item.serviceRating.assistedGood : 0 }}
              </span>
              <span class="mx-1">|</span>
              <span class="amber--text text--darken-2">
                {{
                  item.serviceRating ? item.serviceRating.assistedNeutral : 0
                }}
              </span>
              <span class="mx-1">|</span>
              <span class="red--text">
                {{ item.serviceRating ? item.serviceRating.assistedBad : 0 }}
              </span>
            </div>
          </div>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { BLOB_CONTAINER_URL } from '@/lib/const';

export default {
  name: 'ManagersTable',

  props: {
    data: Array,
    loading: Boolean,
  },

  data() {
    return {
      blobContainerUrl: BLOB_CONTAINER_URL,

      headers: [
        { text: 'Пошта', value: 'email' },
        { text: 'Нікнейм', value: 'nickname' },
        { text: 'Повідомлення', value: 'messageCount', align: 'center' },
        {
          text: 'Рейтинг (Good | Neutral | Bad | Assist)',
          value: 'serviceRating',
          align: 'center',
          sortable: false,
        },
      ],
    };
  },
};
</script>
